import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { BLOG_POSTS } from "../data/blogPosts";

export default function BlogTeaser() {
  return (
    <section data-testid="home-blog-teaser" className="bg-[color:var(--he-bg)] py-24 md:py-32 border-t border-[color:var(--he-line)]">
      <div className="he-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="overline mb-5 mag-marker"><span>Póthaj blog</span></p>
            <h2 className="font-serif-display text-[2.2rem] md:text-[3.4rem] leading-[1.05] tracking-[-0.018em]">
              Útmutatók a <span className="italic text-[color:var(--he-gold)]">tökéletes hajhoz.</span>
            </h2>
          </div>
          <Link to="/blog" className="btn-ghost" data-testid="home-blog-all">
            <span>Összes cikk</span>
            <ArrowUpRight size={14} className="ghost-arrow" />
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14">
          {BLOG_POSTS.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="group grid grid-cols-[120px_1fr] md:grid-cols-[180px_1fr] gap-6 items-center" data-testid={`home-blog-${p.slug}`}>
              <div className="overflow-hidden aspect-square">
                <img src={p.image} alt={p.imageAlt} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
              </div>
              <div>
                <p className="overline-xs text-[color:var(--he-gold)] mb-2">{p.category} · {p.readTime}</p>
                <h3 className="font-serif-display text-xl md:text-2xl leading-snug">{p.title}</h3>
                <p className="mt-2 text-sm text-[color:var(--he-ink-soft)] font-light leading-relaxed hidden md:block">{p.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
